import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface SendProposalDialogData {
  numero: number;
  dataInserimento: string | null;
}

// Conferma dell'invio; «Resta aggiornato» chiede le notifiche dei passaggi di stato
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-send-proposal-dialog',
  imports: [TranslocoPipe, DatePipe, MatButtonModule, MatCheckboxModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>{{ 'orders.ui.inviaProposta' | transloco }}</h2>
    <mat-dialog-content class="send-content">
      <span class="body-medium">
        {{ 'orders.ui.staiPerInviareLaPropostaDOrdine' | transloco }}
        <strong>{{ 'orders.ui.del' | transloco: { value0: (data.numero), value1: (data.dataInserimento | date: 'dd/MM/yyyy') } }}</strong>{{ 'orders.ui.seiSicuroDiVolerProcedere' | transloco }}
      </span>
      <mat-checkbox [checked]="notify" (change)="notify = $event.checked">{{ 'orders.ui.restaAggiornato' | transloco }}</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton type="button" mat-dialog-close>{{ 'orders.ui.annulla' | transloco }}</button>
      <button matButton="filled" type="button" (click)="send()">{{ 'orders.ui.inviaProposta' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .send-content {
      display: flex;
      flex-direction: column;
      gap: var(--mat-sys-spacing-8);
    }
  `,
})
export class SendProposalDialog {
  private readonly dialogRef = inject<MatDialogRef<SendProposalDialog, { notify: boolean }>>(MatDialogRef);
  readonly data = inject<SendProposalDialogData>(MAT_DIALOG_DATA);
  notify = false;

  send(): void {
    this.dialogRef.close({ notify: this.notify });
  }
}
